import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import { Modal, Spin } from 'antd'
import {withTranslation} from 'react-i18next'
import TemplateSearchForm from './TemplateSearchForm'
import TemplateSearchResult from './TemplateSearchResult'
@inject('marketingSmsManagementStore', 'marketingSmsTemplateStore')
@observer
class TemplateList extends Component {
  state = {
  }

  formRef = React.createRef()

  componentDidMount() {
  }
  render() {
    const { marketingSmsTemplateStore, addModalVisible, handleCancel, onChangeInsertModel, type, marketGroupId, t } = this.props
    const { isFetching } = marketingSmsTemplateStore
    return (
      <>
        <Modal
          title={t(`marketingManagement.modelList`)}
          closable={true}
          visible={addModalVisible}
          onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          width={'60%'}
          centered
          footer={false}
          className='shortLinkModel'
        >
          <Spin spinning={isFetching}>
            <TemplateSearchForm type={type} marketGroupId={marketGroupId} />
            <TemplateSearchResult type={type} handleCancel={handleCancel} onChangeInsertModel={onChangeInsertModel} />
          </Spin>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(TemplateList)
